export const RULE_CANVAS_GRID_SIZE = 24;
export const LOOP_SUB_CANVAS_MIN_ZOOM = 0.02;
